import React, { useState } from 'react';

import SatButton from '@components/common/satUI/SatButton';
import { useDispatch, useSelector } from 'react-redux';
import ComingSoonPopup from '@components/common/ComingSoonPopup';
import { getDigitalParamedic } from '@store/actions/appListAction';
import { showModal } from '@store/actions/commonAction';

const AddtionalDiagnosisPopup = props => {
  const {
    setBizModal,
    ownerCustId,
    policyNo,
    applicationNo,
    insuredName,
    modalNumber,
    setComingSoon,
    productCode,
  } = props;
  const { channelInfo } = useSelector(state => state.userReducer);
  const dispatch = useDispatch();
  const handleButtonClick = type => {
    if (type === '1') {
      ownerCustId
        ? // 추가진단신청
          setBizModal({
            modalNumber,
            modalProps: { visible: true, type: 'fullPop' },
            bizProps: {
              ownerCustId,
              policyNo,
              modalKey: 'ADDITION_DIAGNOSIS',
              applicationNo,
              productCode,
            },
          })
        : dispatch(
            showModal({
              visible: true,
              type: 'info',
              msg: '고객정보 조회 실패하였습니다.',
            }),
          );

      // setIsVisible(true);
    } else {
      // 건강평점신청
      setBizModal({
        modalNumber,
        modalProps: {
          visible: true,
          wide: true,
          hideCloseButton: true,
        },
        bizProps: {
          policyNo,
          applicationNo,
          ownerCustId,
          insuredName,
          modalKey: 'HEALTH_RATING',
        },
      });
    }
  };

  return (
    <React.Fragment>
      <div className="cont">
        <p className="layer-text text-center">
          추가진단 신청 방법을 선택해주세요.
          <br />
          방문검진을 신청하시거나, 건강평점을
          <br />
          이용해 검진을 생략하실 수 있어요.
        </p>
        <div className="btn-select">
          <SatButton
            styleClass={'btn-list'}
            label={'방문검진 신청'}
            onClick={() => handleButtonClick('1')}
          />
          <SatButton
            styleClass={'btn-checknote'}
            label={'건강평점 신청'}
            onClick={() => handleButtonClick('2')}
          />
        </div>
      </div>
      {/*<ComingSoonPopup*/}
      {/*  visible={comingSoon}*/}
      {/*  setVisible={() => setComingSoon(false)}*/}
      {/*/>*/}
    </React.Fragment>
  );
};

export default AddtionalDiagnosisPopup;
